import axios from 'axios'
// Specific Account Data
const fetchAccountReports = (payload) => {
  const accountId = payload.accountId;
  delete payload.accountId;
  return axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/api/dataReporting/${accountId}`, payload)
    .then(({ data }) => {
      return data;
    })
    .catch(error => {
      console.log(`###API Fetch Specific Account Reports Error: ${error}`);
      throw error;
    });
};
// All Account Aggregate data
const fetchAllAccountsReports = (payload) => {
  return axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/api/dataReporting/`, payload)
    .then(({ data }) => {
      return data;
    })
    .catch(error => {
      console.log(`###API Fetch All Accounts Reports Error: ${error}`);
      throw error;
    });
};
// Summary Data
const fetchSummaryReports = (payload) => {
  let url = `${process.env.VUE_APP_API_ENDPOINT}/api/dataReporting/summary`;
  if ('accountId' in payload && payload.accountId !== '') {
    url = `${url}/${payload.accountId}`
  } else {
    url = `${url}/1`
  }
  return axios
    .get(url)
    .then(({ data }) => {
      return data;
    })
    .catch(error => {
      console.log(`###API Fetch Summary Reports Error: ${error}`);
      throw error;
    });
};

const saveTimeZone = (payload) => {
  return axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/api/account/${payload.value.accountId}/customerOps`, payload)
    .then(({ data }) => {
      return data;
    })
    .catch(error => {
      console.log(`###API Save Timezone Error: ${error}`);
      throw error;
    });
};

export default {
  fetchAccountReports,
  fetchAllAccountsReports,
  fetchSummaryReports,
  saveTimeZone
};
